// extracted by mini-css-extract-plugin
export default {"DictionaryContainer":"Thanks_DictionaryContainer__8IVJO","productBanner":"Thanks_productBanner__3WVw9","DictionaryMainContainer":"Thanks_DictionaryMainContainer__02X+Z"};